import { getStoreInfoFromSlug, updateSellerStatus } from '../../tools/ciblerAPI';
import { RequirementsProps } from '../../tools/context';
import { getStoreInfoFromProvider, StoreInfoProvider } from '../../tools/providersAPI';
import { Renderer } from '../ShopV2';

const preloader = async (_: any, requirements: RequirementsProps) => {
  try {
    const sellerSlug = requirements.parameters[0];

    if (!!!sellerSlug) throw new Error('sellerSlug is required');

    const storeInfo = await getStoreInfoFromSlug(sellerSlug, requirements);
    if (!storeInfo) {
      return (window.location.href = '/404');
    }

    const providers: StoreInfoProvider[] = ['apidae'];
    const provider = providers.find((p) => storeInfo.data?.[`${p}_id`]);
    const sellerId = storeInfo.seller?.id;

    // Aucun apidae_id sur le seller → on considère la fiche comme obsolète/invalide
    // et on passe le seller en `denied` côté CIBLER, comme pour un 404 Apidae.
    if (!provider) {
      if (sellerId) {
        await updateSellerStatus(sellerId, requirements);
      }
      return (window.location.href = '/404');
    }

    const customData = await getStoreInfoFromProvider(
      requirements,
      provider,
      storeInfo.data[`${provider}_id`],
      sellerId
    );

    // If the seller has an Apidae ID but Apidae returns null (404/invalid),
    // the object no longer exists in Apidae — return 404
    if (customData === null) {
      return (window.location.href = '/404');
    }

    return {
      ...storeInfo,
      customData,
    };
  } catch (error) {
    return null;
  }
};

const headers = (state: any) => {
  const headers = [];

  headers.push(`<link rel="canonical" href="/fiche-sit/${state?.data?.slug}">`);

  const proName = state?.customData?.fr?.store?.name || state?.seller?.name;
  if (proName) {
    headers.push(`<meta name="name" content="${proName}">`);
    headers.push(`<title>${proName}</title>`);
    headers.push(`<meta property="og:title" content="${proName}">`);
    headers.push(`<meta property="og:site_name" content="${proName}">`);
    headers.push(`<meta property="og:url" content="/fiche-sit/${state?.data?.slug}">`);
    headers.push(`<meta property="og:type" content="website">`);
  }

  if (state?.data || state?.customData) {
    const d = state.data;
    const cD = state.customData?.fr;
    const addressFromCustomData = cD?.store?.address;

    headers.push(
      `<meta name="address" content="${addressFromCustomData?.address1 || d.street || ''} ${
        addressFromCustomData?.postalCode || d?.zipcode || ''
      } ${cD?.city || d?.city || ''}">`
    );
    headers.push(
      `<meta name="description" content="${cD?.store?.description || state?.data.description || ''}">`
    );

    if (state.data.noindex === 'true') {
      headers.push('<meta name="robots" content="noindex">');
      headers.push('<meta name="googlebot" content="noindex">');
    }
  }

  if (state?.images?.length) {
    headers.push(`<meta property="og:image" content="${state.images[0]}">`);
  }

  return headers;
};

const Shop = { Renderer, preloader, headers };

export default Shop;
export { Renderer, preloader };
